import { render } from "./AgingReport.vue?vue&type=template&id=75aa4050"
import script from "./AgingReport.vue?vue&type=script&lang=ts"
export * from "./AgingReport.vue?vue&type=script&lang=ts"
script.render = render

export default script